import currentConferencePhase from '../experience/conference'

const ancestryId = '0000017c-c7b2-d348-af7c-c7f634960000'

const expoHallConfig = {
  opens: currentConferencePhase.starts,
  // NOTE: generally this happens at the end of 3rd quarter.
  closes: '2027-08-13T18:00:00-06:00',
  locales: ['en', 'de', 'fr', 'it', 'es', 'pt'],
  promotions: {
    editDeadline: '2027-02-28T07:00:00.000Z',
    starts: '2027-03-04T05:00:00-07:00',
    ends: '2027-04-01T07:00:00-07:00',
    path: '/expohall',
  },
  searchTopics: [
    'Charts',
    'DNA',
    'Professionals',
    'Storytelling',
    'Travel',
    'Records',
    'Research',
    'Preservation',
    'Family History',
    'Technology',
    'Connection',
    'Tree Chart',
    'Search Family',
    'Society',
    'Association',
    'Library',
  ],
  sponsors: {
    withDisclaimers: [ancestryId],
    platinum: ['ancestry', 'familysearch', 'myheritage', 'storied'],
  },
}

export default expoHallConfig
